/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboGetsentineloneagentsidinstalledapplicationsSentinelOneInstalledApplications
 */
export interface JumboGetsentineloneagentsidinstalledapplicationsSentinelOneInstalledApplications {
    /**
     * 
     * @type {string}
     * @memberof JumboGetsentineloneagentsidinstalledapplicationsSentinelOneInstalledApplications
     */
    installedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboGetsentineloneagentsidinstalledapplicationsSentinelOneInstalledApplications
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboGetsentineloneagentsidinstalledapplicationsSentinelOneInstalledApplications
     */
    publisher?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboGetsentineloneagentsidinstalledapplicationsSentinelOneInstalledApplications
     */
    riskLevel?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboGetsentineloneagentsidinstalledapplicationsSentinelOneInstalledApplications
     */
    version?: string;
}

/**
 * Check if a given object implements the JumboGetsentineloneagentsidinstalledapplicationsSentinelOneInstalledApplications interface.
 */
export function instanceOfJumboGetsentineloneagentsidinstalledapplicationsSentinelOneInstalledApplications(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboGetsentineloneagentsidinstalledapplicationsSentinelOneInstalledApplicationsFromJSON(json: any): JumboGetsentineloneagentsidinstalledapplicationsSentinelOneInstalledApplications {
    return JumboGetsentineloneagentsidinstalledapplicationsSentinelOneInstalledApplicationsFromJSONTyped(json, false);
}

export function JumboGetsentineloneagentsidinstalledapplicationsSentinelOneInstalledApplicationsFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboGetsentineloneagentsidinstalledapplicationsSentinelOneInstalledApplications {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'installedAt': !exists(json, 'installedAt') ? undefined : json['installedAt'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'publisher': !exists(json, 'publisher') ? undefined : json['publisher'],
        'riskLevel': !exists(json, 'riskLevel') ? undefined : json['riskLevel'],
        'version': !exists(json, 'version') ? undefined : json['version'],
    };
}

export function JumboGetsentineloneagentsidinstalledapplicationsSentinelOneInstalledApplicationsToJSON(value?: JumboGetsentineloneagentsidinstalledapplicationsSentinelOneInstalledApplications | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'installedAt': value.installedAt,
        'name': value.name,
        'publisher': value.publisher,
        'riskLevel': value.riskLevel,
        'version': value.version,
    };
}

